import React, { FC } from "react"
import { DefaultMoodIconSize } from "../../utils/constants"
import { MoodIconProps } from "../../utils/types"

const GrowthIcon: FC<MoodIconProps> = ({
  x,
  y,
  backgroundColor,
  height = DefaultMoodIconSize,
  width = DefaultMoodIconSize,
}) => {
  return (
    <svg
      width={height}
      height={width}
      viewBox="0 0 22 22"
      fill="none"
      x={x}
      y={y}
    >
      <circle
        cx="10.9999"
        cy="11.0002"
        r="9.16667"
        fill={!backgroundColor ? "white" : backgroundColor}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0028 0.22998C16.9514 0.22998 21.7737 5.05225 21.7737 11.0008C21.7737 16.9494 16.9514 21.7716 11.0028 21.7716C5.05428 21.7716 0.232014 16.9494 0.232014 11.0008C0.232014 5.05225 5.05428 0.22998 11.0028 0.22998ZM11.0028 19.48C15.6858 19.48 19.482 15.6837 19.482 11.0008C19.482 6.3179 15.6858 2.52165 11.0028 2.52165C6.31993 2.52165 2.52368 6.3179 2.52368 11.0008C2.52368 15.6837 6.31993 19.48 11.0028 19.48Z"
        fill="#7591E4"
      />
      <path
        d="M12.1487 15.1258C12.1487 15.7586 11.6357 16.2716 11.0028 16.2716C10.4096 16.2716 9.92161 15.8208 9.86293 15.243L9.85701 15.1258L9.85701 6.87581C9.85701 6.24299 10.37 5.72998 11.0028 5.72998C11.5961 5.72998 12.0841 6.18087 12.1428 6.75866L12.1487 6.87581L12.1487 15.1258Z"
        fill="#7591E4"
      />
      <path
        d="M15.2506 9.50309C15.6981 9.95056 15.6981 10.6761 15.2506 11.1235C14.8329 11.5412 14.1731 11.569 13.7232 11.2071L13.6301 11.1235L11.0028 8.49556L8.37557 11.1235C7.95793 11.5412 7.2981 11.569 6.84816 11.2071L6.75512 11.1235C6.33748 10.7059 6.30963 10.0461 6.67159 9.59612L6.75512 9.50309L10.1926 6.06559C10.6103 5.64794 11.2701 5.6201 11.72 5.98206L11.8131 6.06559L15.2506 9.50309Z"
        fill="#7591E4"
      />
    </svg>
  )
}

export default GrowthIcon
